import { Col, Row } from "react-bootstrap";
function StackGrid({ icons }) {
    return (
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
            {icons.map((E) => (
                <Col xs={4} md={2} className="tech-icons">
                    <E />
                </Col>
            ))}
        </Row>
    );
}

export default StackGrid;